export const FHA_FULL_SIZE = 'full-size';
export const FHA_THUMBNAIL = 'preview';

export const PLANET_LABS_IMAGERY_POC = 'planet-scope';
export const PLANET_LABS_IMAGERY_8_BITS = 'planetscope-8-bit'; // imagery created in hackathon
